import React from 'react'

export const UpChevronIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={'14'}
    height={'8'}
    viewBox={'0 0 14 8'}
    fill={'none'}
    {...props}
  >
    <path
      d={'M13 7L7 1L1 7'}
      stroke={'currentColor'}
      strokeWidth={'2'}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
    />
  </svg>
)
